import { gql } from "@apollo/client";

// Danh sách chương trình chiết khấu
export const GET_PACKAGE_LIST = gql`
  query GetPackageList($filters: ListLoyaltyPackagesFilters, $pagination: PaginationRequest!) {
    loyaltyPackage {
      listPackages(filters: $filters, pagination: $pagination) {
        paginationData {
          total
          limit
          offset
        }
        packages {
          id
          isActive
          title
          startTime
          endTime
          policy
          status
          numOfPeriods
          createdAt
          updatedAt
          createdBy {
            id
            fullname
          }
        }
      }
    }
  }
`;

// Chi tiết một chương trình chiết khấu
export const GET_PACKAGE = gql`
  query GetPackage($id: ID!) {
    loyaltyPackage {
      getPackage(id: $id) {
        id
        title
        policy
        startTime
        endTime
        status
        isActive
        numOfPeriods
        createdAt
        updatedAt
        createdBy {
          id
          fullname
        }
      }
    }
  }
`;

// Danh sách gói chiết khấu (Period)
export const LIST_PERIODS = gql`
  query ListPeriods($filters: ListLoyaltyPackagePeriodsFilters, $pagination: PaginationRequest!) {
    loyaltyPackage {
      listPeriods(filters: $filters, pagination: $pagination) {
        paginationData {
          total
          limit
          offset
        }
        periods {
          id
          title
          startTime
          endTime
          isActive
          loyaltyPackageId
          loyaltyPackage {
            id
            title
          }
          timeInterval
          productPackageType
          numOfProducts
          category {
            id
            name
          }
          createdById
          createdBy {
            id
            fullname
          }
          createdAt
          updatedAt
        }
      }
    }
  }
`;

// Chi tiết một gói chiết khấu
export const GET_PERIOD = gql`
  query GetPeriod($id: ID!) {
    loyaltyPackage {
      getPeriod(id: $id) {
        id
        title
        startTime
        endTime
        isActive
        loyaltyPackageId
        timeInterval
        productPackageType
        categoryId
        numOfProducts
        category {
          id
          name
        }
        config {
          awards {
            minItems
            maxItems
            award {
              awardAmount
              awardValue
              awardUnit
              position
              displayPosition
              awardAmountTitle
            }
          }
        }
        products {
          productId
          product {
            id
            name
            code
            imageURL
          }
          config {
            awards {
              minItems
              maxItems
              award {
                awardAmount
                awardValue
                awardUnit
                position
                displayPosition
                awardAmountTitle
              }
            }
          }
        }
        createdById
        createdBy {
          id
          fullname
        }
        createdAt
        updatedAt
      }
    }
  }
`;

// Xem chi tiết gói (lightweight, chỉ fields cần cho màn detail)
export const GET_PERIOD_DETAIL = gql`
  query GetPeriodDetail($id: ID!) {
    loyaltyPackage {
      getPeriod(id: $id) {
        id
        title
        startTime
        endTime
        category {
          id
          name
        }
        config {
          awards {
            minItems
            maxItems
            award {
              awardValue
              awardUnit
              displayPosition
              awardAmountTitle
            }
          }
        }
        products {
          productId
          product {
            id
            name
            code
          }
          config {
            awards {
              award {
                awardValue
                awardUnit
              }
            }
          }
        }
      }
    }
  }
`;

// Lightweight — Chỉ lấy category đến level 2, không attributes (tránh timeout)
// Dùng cho dropdown Ngành hàng trong form Gói chiết khấu
export const GET_LOYALTY_CATEGORIES_QUERY = gql`
  query GetLoyaltyCategories($req: CategoriesFilters) {
    category {
      list(req: $req) {
        id
        name
        level
        isActive
        children {
          id
          name
          level
          isActive
        }
      }
    }
  }
`;
